import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
// Import Role constants if needed for comparison clarity
// import { ROLES } from '../types/enums';

const AdminRoute: React.FC = () => {
  // 获取 authLoading
  const { isAuthenticated, user, authLoading } = useAuth();
  const location = useLocation();

  // 1. 检查加载状态
  if (authLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // 2. 加载完成后，检查是否已认证
  if (!isAuthenticated) {
    console.log("AdminRoute: Not authenticated after loading, redirecting to login.");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. 检查用户是否存在且角色是否为 ADMIN
  if (!user || user.role !== 'ADMIN') {
    console.log(`AdminRoute: Access denied after loading. User role is ${user?.role || 'null'}. Redirecting.`);
    return <Navigate to="/login" replace />;
  }

  // 4. 允许访问
  console.log("AdminRoute: Access granted after loading for admin user.");
  return <Outlet />;
};

export default AdminRoute; 